import React from "react"
import { cn } from "design_system/libs"
import Tooltip from "design_system/core/components/tooltip"
import { getTypeLabelTranslation } from "@love-irish/i18n"

export interface TypeLabelProps {
  /** Icon component to display */
  icon: React.ComponentType<{ size?: number; className?: string }>
  /** Label text (e.g., "Book", "Website"). Rendered bilingually as `Leabhar · Book` when i18n has Irish. */
  label: string
  /** Optional tooltip text */
  tooltip?: string
  /** Additional CSS classes */
  className?: string
  wrapperClass?: string
}

export const TypeLabel: React.FC<TypeLabelProps> = ({
  icon: Icon,
  label,
  tooltip,
  className,
  wrapperClass,
}) => {
  // Bilingual chip: Irish first, English muted second (mirrors the read-more link). Falls back to
  // English-only when we don't have an Irish translation for this label yet.
  const { text, translation } = getTypeLabelTranslation(label)

  const content = (
    <div
      className={cn(
        "flex gap-2 items-center text-xs text-foreground",
        className
      )}
    >
      <Icon
        className="text-muted-foreground inline-block align-middle"
        size={16}
      />
      {translation ? (
        <span className="flex items-center gap-1">
          <span>{translation}</span>
          <span className="text-muted-foreground">·</span>
          <span className="text-muted-foreground">{text}</span>
        </span>
      ) : (
        text
      )}
    </div>
  )

  if (tooltip) {
    return (
      <Tooltip title={tooltip} wrapperClass={wrapperClass}>
        {content}
      </Tooltip>
    )
  }

  return content
}

export default TypeLabel
